var exports = {
  "x": "x2b2fbebb--fcb003--button",
};

module.exports = exports;
